import React, { type ReactElement } from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import AssistantViewController from '../AssistantView/AssistantViewController';
import styles from '../PromptPanel/PromptPanel.module.css';
import conversationStyles from './ConversationPanel.module.css';
import type Attachment from '../../../framework/models/Attachment';

const MessageAttachment = ({ attachment }: { attachment: Attachment }) => {
  const controller = useController(AssistantViewController);

  const isImage = attachment.contentType?.startsWith('image/') ?? false;
  let content: ReactElement | null = null;

  if (isImage) {
    content = (
      <img
        className={styles.attachmentImage}
        src={attachment.downloadUrl}
        alt={attachment.fileName}
      />
    );
  } else {
    content = (
      <div className={conversationStyles.userMessageScopeItem}>
        <i className='far fa-file-lines' />
        <span>{attachment.fileName}</span>
      </div>
    );
  }

  return (
    <div
      className={styles.attachment}
      key={attachment.id}
      onClick={() => {
        controller.actionShowAttachment(attachment);
      }}
    >
      {content}
    </div>
  );
};

export default ApplicationView(MessageAttachment);
